import api from '../../services/api.js'
import TokenService from '../../services/tokenService.js'

const state = {
  username: null,
  entreprise: null,
  endFreeAccess: null,
  subscriptionType: null,
  currentUserSubscription: null,
  pictureUrl: null,
  pictureReframe: false,
  listEntreprises: [],
  roles: [],
  rememberMe: null,
  isAdmin: null,
  isEstateAgent: null,
  isCollaborator: null,
  isCollaboratorPlus: null,
  isAgentImmo: null,
  userId: null,
  impersonateUsername: null,
  masterUserId: null,
  impersonateRoles: []
}

const getters = {
  isAuthenticated: (state) => state.username != null,
  username: (state) => state.username,
  entreprise: (state) => state.entreprise,
  endFreeAccess: (state) => state.endFreeAccess,
  subscriptionType: (state) => state.subscriptionType,
  currentUserSubscription: (state) => state.currentUserSubscription,
  pictureUrl: (state) => state.pictureUrl,
  pictureReframe: (state) => state.pictureReframe,
  listEntreprises: (state) => state.listEntreprises,
  roles: (state) => state.impersonateUsername ? state.impersonateRoles : state.roles,
  userId: (state) => state.userId,
  isAdmin: (state) => state.isAdmin,
  isEstateAgent: (state) => state.isEstateAgent,
  isCollaborator: (state) => state.isCollaborator,
  isAgentImmo: (state) => state.isAgentImmo,
  isCollaboratorPlus: (state) => state.isCollaboratorPlus,
  isRememberMe: (state) => state.rememberMe,
  impersonateUsername: (state) => state.impersonateUsername,
  masterUserId: (state) => state.masterUserId,
}

const actions = {

  async LogIn({commit}, data) {
    await api({
      method: 'POST',
      url: '/api/login',
      data: JSON.stringify(data),
      headers: {'content-type': 'application/json'}

    }).then(response => {
      commit('didLogIn', response)
    })
  },

  refreshToken({commit}, response) {
    commit('didRefreshToken', response)
  },

  setRememberMe({commit}, rememberMe) {
    commit('setRememberMe', rememberMe)
  },

  leaveImpersonateMode({commit}) {
    commit('leaveImpersonateMode')
  },

  setImpersonateMode({commit}, data) {
    commit('setImpersonateMode', data)
  },

  leaveMultiEntreprise({commit}, data) {
    commit('leaveMultiEntreprise', data)
  },

  updateListEntreprises({commit}, data) {
    commit('updateListEntreprises', data)
  },

  changeUserEstateAgent({commit}, data) {
    commit('changeUserEstateAgent', data)
  },

  async LogOut({commit}) {
    commit('didLogOut')
  }
}

const mutations = {

  didLogIn(state, response) {
    TokenService.setUser(response.data)
    state.username = response.data.username
    state.entreprise = response.data.entreprise
    state.endFreeAccess = response.data.endFreeAccess
    state.subscriptionType = response.data.subscriptionType
    state.currentUserSubscription = response.data.currentUserSubscription
    state.pictureUrl = response.data.pictureUrl
    state.pictureReframe = response.data.pictureReframe
    state.roles = response.data.roles
    state.listEntreprises = response.data.listEntreprises
    state.userId = response.data.id
    state.isAdmin = state.roles.includes('ROLE_ADMIN')
    state.isEstateAgent = state.roles.includes('ROLE_ESTATE_AGENT')
    state.isCollaborator = state.roles.includes('ROLE_COLLABORATOR')
    state.isAgentImmo = state.roles.includes('ROLE_AGENT_IMMO')
    state.isCollaboratorPlus = state.roles.includes('ROLE_COLLABORATOR_PLUS')
    state.masterUserId = null

    if (response.data.isLNIGroup) {
      this.commit('brand/SET_BRAND', 'LNI')
    } else {
      this.commit('brand/SET_BRAND', 'APRILYOS')
    }

  },

  didRefreshToken(state, response) {
    TokenService.setUser(response.data)
  },

  didLogOut(state) {
    TokenService.removeUser()
    TokenService.removeImpersonate()
    state.username = null
    state.entreprise = null
    state.currentUserSubscription = null
    state.endFreeAccess = null
    state.subscriptionType = null
    state.pictureUrl = null
    state.pictureReframe = null
    state.roles = []
    state.userId = null
    state.isAdmin = false
    state.listSociete = false
    state.isEstateAgent = false
    state.isCollaborator = false
    state.isAgentImmo = false
    state.isCollaboratorPlus = false
    state.impersonateUsername = null
    state.impersonateRoles = []
    state.listEntreprises = []
    const host = window.location.hostname.toLowerCase()
    if (host.includes("lni")) {
      this.commit('brand/SET_BRAND', 'LNI')
    } else {
      this.commit('brand/SET_BRAND', 'APRILYOS')
    }

  },

  setRememberMe(state, rememberMe) {
    state.rememberMe = rememberMe
  },

  updateEntreprise(state, newEntreprise) {
    state.entreprise = newEntreprise
  },

  leaveImpersonateMode(state) {
    state.isAdmin = true
    state.isEstateAgent = false
    state.isCollaborator = false
    state.isAgentImmo = false
    state.isCollaboratorPlus = false
    state.impersonateUsername = null
    state.masterUserId = null
    state.impersonateRoles = []
    this.commit('brand/SET_BRAND', 'APRILYOS')
  },

  setImpersonateMode(state, data) {
    state.isAdmin = false
    state.isEstateAgent = data.roles.includes("ROLE_ESTATE_AGENT")
    state.isCollaborator = data.roles.includes("ROLE_COLLABORATOR")
    state.isCollaboratorPlus = data.roles.includes("ROLE_COLLABORATOR_PLUS")
    state.isAgentImmo= data.roles.includes("ROLE_AGENT_IMMO")
    state.impersonateUsername = data.username
    state.impersonateRoles = data.roles
    state.entreprise = data.entreprise
    state.endFreeAccess = data.endFreeAccess
    state.pictureUrl = data.picture
    state.pictureReframe = data.pictureReframe
    state.listEntreprises = data.listEntreprises
    state.currentUserSubscription = data.currentUserSubscription
    state.masterUserId = data.masterUserId
    if (data.isLNIGroup) {
      this.commit('brand/SET_BRAND', 'LNI')
    } else {
      this.commit('brand/SET_BRAND', 'APRILYOS')
    }
  },

  leaveMultiEntreprise(state, data) {
    state.username = data.username
    state.entreprise = data.entreprise
    state.endFreeAccess = data.endFreeAccess
    state.subscriptionType = data.subscriptionType
    state.currentUserSubscription = data.currentUserSubscription
    state.pictureUrl = data.pictureUrl
    state.pictureReframe = data.pictureReframe
    state.roles = data.roles
    state.listEntreprises = data.listEntreprises
    state.userId = data.id
    state.isAdmin = data.roles.includes('ROLE_ADMIN')
    state.isEstateAgent = data.roles.includes('ROLE_ESTATE_AGENT')
    state.isCollaborator = data.roles.includes('ROLE_COLLABORATOR')
    state.isAgentImmo = data.roles.includes('ROLE_AGENT_IMMO')
    state.isCollaboratorPlus = data.roles.includes('ROLE_COLLABORATOR_PLUS')
    state.masterUserId = null
  },


  updateListEntreprises(state, data) {
    state.listEntreprises = []
    for(const entreprise of data) {
      state.listEntreprises.push([entreprise.username, entreprise.entreprise])
    }
  },

  changeUserEstateAgent(state, data) {
    state.entreprise = data.entreprise
    state.pictureUrl = data.pictureUrl
    state.pictureReframe = data.pictureReframe
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js